import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installUnsavedChangesGuard } from './hooks/useUnsavedChanges';
import './styles/admin.css';
import './styles/workspace.css';

installUnsavedChangesGuard();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
